var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9974 31.6667C14.9974 32.9167 14.6474 34.1 14.0307 35.1C12.8807 37.0333 10.7641 38.3333 8.33073 38.3333C5.8974 38.3333 3.78073 37.0333 2.63073 35.1C2.01407 34.1 1.66406 32.9167 1.66406 31.6667C1.66406 27.9833 4.6474 25 8.33073 25C12.0141 25 14.9974 27.9833 14.9974 31.6667Z",
    stroke: "#37D881",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73438 31.666L7.38438 33.316L10.9344 30.0327",
    stroke: "#37D881",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.587 11.7501C29.187 11.6834 28.7703 11.6668 28.337 11.6668H11.6703C11.2036 11.6668 10.7536 11.7001 10.3203 11.7668C10.5536 11.3001 10.887 10.8668 11.287 10.4668L16.7036 5.0335C18.987 2.76683 22.687 2.76683 24.9703 5.0335L27.887 7.98343C28.9536 9.03343 29.5203 10.3668 29.587 11.7501Z",
    stroke: "#37D881",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6693 19.9998V28.3332C36.6693 33.3332 33.3359 36.6665 28.3359 36.6665H12.7193C13.2359 36.2332 13.6859 35.6998 14.0359 35.0998C14.6526 34.0998 15.0026 32.9165 15.0026 31.6665C15.0026 27.9832 12.0193 24.9998 8.33594 24.9998C6.33594 24.9998 4.5526 25.8831 3.33594 27.2665V19.9998C3.33594 15.4665 6.06927 12.2998 10.3193 11.7665C10.7526 11.6998 11.2026 11.6665 11.6693 11.6665H28.3359C28.7693 11.6665 29.1859 11.6832 29.5859 11.7498C33.8859 12.2498 36.6693 15.4332 36.6693 19.9998Z",
    stroke: "#37D881",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6693 20.8335H31.6693C29.8359 20.8335 28.3359 22.3335 28.3359 24.1668C28.3359 26.0002 29.8359 27.5002 31.6693 27.5002H36.6693",
    stroke: "#37D881",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletCheck);
export default __webpack_public_path__ + "static/media/wallet-check.4d2cc801b32cd36404ae1714b3237cdd.svg";
export { ForwardRef as ReactComponent };